<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  hasInboxes: {
    type: Boolean,
    default: false,
  },
  isSyncDisabled: {
    type: Boolean,
    default: false,
  },
  isSyncingTemplates: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['redirectToSetup', 'syncTemplates']);

const { t } = useI18n();
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="flex justify-center items-center min-h-96 animate-[fadeIn_0.5s_ease-in-out]"
  >
    <!-- No WhatsApp inbox configured -->
    <div
      v-if="!hasInboxes"
      class="bg-white dark:bg-slate-800 rounded-2xl p-12 shadow-lg border border-green-100 dark:border-green-800 text-center max-w-md"
    >
      <div class="text-6xl mb-4">📱</div>
      <h3 class="text-xl font-semibold text-slate-900 dark:text-white mb-2">
        {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.NO_INBOX_TITLE') }}
      </h3>
      <p class="text-slate-600 dark:text-slate-400 mb-6 leading-relaxed">
        {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.NO_INBOX_DESCRIPTION') }}
      </p>
      <div class="flex justify-center">
        <button
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors border-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          @click="emit('redirectToSetup')"
        >
          🔧 {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.SETUP_INBOX') }}
        </button>
      </div>
    </div>

    <!-- Has inboxes but no templates -->
    <div
      v-else
      class="bg-white dark:bg-slate-800 rounded-2xl p-12 shadow-lg border border-green-100 dark:border-green-800 text-center max-w-md"
    >
      <div class="text-6xl mb-4">📝</div>
      <h3 class="text-xl font-semibold text-slate-900 dark:text-white mb-2">
        {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.NO_TEMPLATES_TITLE') }}
      </h3>
      <p class="text-slate-600 dark:text-slate-400 mb-6 leading-relaxed">
        <span v-if="isSyncDisabled">
          {{
            t(
              'CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.NO_TEMPLATES_DESCRIPTION_DISABLED'
            )
          }}
        </span>
        <span v-else>
          {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.NO_TEMPLATES_DESCRIPTION') }}
        </span>
      </p>
      <div class="flex justify-center">
        <button
          :disabled="isSyncingTemplates || isSyncDisabled"
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors border-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          @click="emit('syncTemplates')"
        >
          {{
            isSyncingTemplates
              ? t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.SYNCING_TEMPLATES')
              : t('CAMPAIGN.WHATSAPP_OFFICIAL.EMPTY.SYNC_TEMPLATES')
          }}
        </button>
      </div>
    </div>
  </div>
  <!-- eslint-enable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
</template>
